export default __webpack_public_path__ + "static/media/circleofmagic.7fbbce62.png";